import React from 'react';

export const COLUMNS_USER =[
    {
        Header              : 'User Code',
        accessor            : 'userCode',
        Cell                : e=><div className="text-center"><a href={'/'+localStorage.getItem("role")+'/view/'+e.value}> {e.value} </a></div>
    },
    {
        Header              : 'User Name',
        accessor            : 'name',
        Cell                : e=><div className="text-center"> {e.value} </div>
    },
    {
        Header              : 'Email',
        accessor            : 'emailId',
        Cell                : e=><div className="text-center"> {e.value} </div>
    },
    {
        Header              : 'Role',
        accessor            : 'role',
        Cell                : e=><div className="text-center"> {e.value} </div>
    },
]